export const ApplicationSettingsRecipe = {
    $type$: 'Recipe',
    name: 'Settings',
    rule: [
        {
            itemprop: 'id',
            itemtype: { type: 'string' },
            isId: true
        },
        {
            itemprop: 'properties',
            itemtype: { type: 'map', key: { type: 'string' }, value: { type: 'stringifiable' } }
        }
    ]
};
const SettingsRecipe = [ApplicationSettingsRecipe];
export default SettingsRecipe;
//# sourceMappingURL=SettingsRecipe.js.map